module.exports = __webpack_public_path__ + "static/img/M2-S-276-1.41ea138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module2/M2-S-276-1.png
// module id = 628
// module chunks = 0